"use client"

import React, { createContext, useContext, useState } from "react"

interface AuthUIContextType {
    hasLoginError: boolean
    setHasLoginError: (hasError: boolean) => void
    failedAttempts: number
    incrementFailedAttempts: () => void
    resetFailedAttempts: () => void
}

const AuthUIContext = createContext<AuthUIContextType | undefined>(undefined)

export function AuthUIProvider({ children }: { children: React.ReactNode }) {
    const [hasLoginError, setHasLoginError] = useState(false)
    const [failedAttempts, setFailedAttempts] = useState(0)

    const incrementFailedAttempts = () => setFailedAttempts(prev => prev + 1)
    const resetFailedAttempts = () => setFailedAttempts(0)

    return (
        <AuthUIContext.Provider value={{
            hasLoginError,
            setHasLoginError,
            failedAttempts,
            incrementFailedAttempts,
            resetFailedAttempts
        }}>
            {children}
        </AuthUIContext.Provider>
    )
}

export function useAuthUI() {
    const context = useContext(AuthUIContext)
    if (context === undefined) {
        throw new Error("useAuthUI must be used within an AuthUIProvider")
    }
    return context
}
